<template>
    <el-upload
     v-if="enableChat"
     :action="avatarUploadUrl"
     :headers="myHeaders"
     :on-success="uploadSuccess"
     :before-upload="beforeUpload"
     :show-file-list="false"
     class="picUpload"
     accept="image/png, image/jpeg, image/jpg">
        <el-tooltip content="发送图片" placement="top" effect="light">
            <span class="picIcon"></span>
        </el-tooltip>
    </el-upload>
    <span v-else class="picIcon"></span>
</template>
<script>
import Operation from "@/request"

export default {
    props: ['imgUploadSuccess', 'enableChat'],
    data() {
        return {
            myHeaders: "",
            avatarUploadUrl: ""
        }
    },
    created() {
        this.getAvatarUploadUrl();
    },
    methods: {
        //拼接头像上传地址
        getAvatarUploadUrl(){
            let token = Operation.SessionStorage.get('token')
            this.myHeaders = { token: token }
            this.avatarUploadUrl = Operation.Const.ApiUrl + "/upload";
        },
        //上传验证
        beforeUpload(file){
            if(this.enableChat) {
            }
            if(!/\.(jpg|png|jpeg)$/.test(file.name)) {
                this.$message({
                    message: "请上传 'jpg' 'png' 格式的图片",
                    type: 'warning'
                });
                return false;
            }
            if(file.size > 5242880) {
                this.$message({
                    message: '图片大小不能超过5M',
                    type: 'warning'
                });
                return false;
            }
        },
        //图片上传成功
        uploadSuccess(response, file, fileList) {
            if(response) {
                this.$emit('imgUploadSuccess', response);
            }
        },
    }
}
</script>
<style scoped>
.picUpload {
    line-height: 0;
}
.picIcon {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 0 2px;
    background-image: url(~@/assets/tic/pic.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/picUpload.vue